import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { Button } from '@guildeducationinc/recess';
import ActionCard from '@shared/ActionCard/ActionCard';
import ActionCardButtons from '@shared/ActionCard/ActionCardButtons';
import ActionCardContent from '@shared/ActionCard/ActionCardContent';
import { CATALOG_URL, MOBILE_QUERY } from '@src/constants';
import { clickable } from '@src/analytics';

const BookmarksActionCard: React.FC = () => {
  const isMobile = useMediaQuery(MOBILE_QUERY);

  const content = {
    estimate: '3-5 MIN',
    title: 'Add bookmarks to see them here.',
    body: 'Save programs so you can easily find them, any time.',
  };

  const icon = {
    src:
      'https://guild.imgix.net/student-home/programs-and-applications/catalog-bookmarks-circle.svg',
    alt: 'Bookmarks',
  };

  return (
    <ActionCard icon={icon} className='width--full'>
      <ActionCardContent {...content} />
      <ActionCardButtons>
        <Button
          fullWidth={isMobile}
          href={CATALOG_URL}
          onClick={() =>
            clickable({
              product: 'home',
              loggedIn: true,
              tag: 'learn_skills',
              text: 'bookmarks_explore_catalog',
              type: 'button',
            })
          }
        >
          Explore catalog
        </Button>
      </ActionCardButtons>
    </ActionCard>
  );
};

export default BookmarksActionCard;
